import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { TranslateService } from '@ngx-translate/core';

interface LenguageItem {
  label : string,
  value : string,
  name : string
}

export enum LenguageName {
  Spanish = 'es' ,
  Enghish = 'en'
}

@Injectable({
  providedIn: 'root'
})
export class LenguageService {

  private lenguageStorageKey : string = "lenguageUser"

  private defaultLenguage : LenguageName = LenguageName.Spanish;


  public currentLenguageSubject: BehaviorSubject<LenguageName>;
  public currentLenguage$: Observable<LenguageName>;


  private lenguagesSubject : BehaviorSubject<LenguageItem[]>;
  public lenguages$ : Observable<LenguageItem[]>;

  constructor(
    private translate : TranslateService,
    private localStorageService : LocalStorageService
  ) {
    this.currentLenguageSubject = new BehaviorSubject<LenguageName>(
      this.loadSavedLenguage() || this.defaultLenguage
    )
    this.currentLenguage$ = this.currentLenguageSubject.asObservable();


    this.translate.setDefaultLang(this.defaultLenguage);
    this.translate.use(this.currentLenguageSubject.value);


    this.lenguagesSubject = new BehaviorSubject<LenguageItem[]>([]);
    this.lenguages$ = this.lenguagesSubject.asObservable();
    const langSub = this.translate.onLangChange.subscribe(() => {
      this.loadLanguages();
    });
  }


  private loadLanguages() {
    const keys = [
      'CONFIGURATION.LANGUAGE.SPANISH',
      'CONFIGURATION.LANGUAGE.ENGLISH',
    ];
    this.translate.get(keys).toPromise().then((translations) => {
      this.lenguagesSubject.next([
        {
          label: translations['CONFIGURATION.LANGUAGE.SPANISH'],
          value: LenguageName.Spanish,
          name: translations['CONFIGURATION.LANGUAGE.SPANISH']
        },
        {
          label: translations['CONFIGURATION.LANGUAGE.ENGLISH'],
          value: LenguageName.Enghish,
          name: translations['CONFIGURATION.LANGUAGE.ENGLISH']
        }
      ]);
      console.log(this.lenguagesSubject.value, 'language Service');
    });
  }



  private loadSavedLenguage() : LenguageName {
    return this.localStorageService.getItem(this.lenguageStorageKey)
  }

  public selectLenguage(lenguage : LenguageName) {
    if(this.currentLenguageSubject.value == lenguage) return
    this.currentLenguageSubject.next(lenguage)
      this.translate.use(lenguage)

    this.saveLenguageToStore(lenguage)

  }

  private saveLenguageToStore(lenguage : LenguageName) {
    this.localStorageService.setItem(this.lenguageStorageKey, lenguage);
  }

}

